import { initializePartnerEventEmitter } from 'lib-integrations-partner-widgets';

import {
  brazePartnerTrackingEvents,
  commonPartnerTrackingEvents,
  githubPartnerTrackingEvents,
  jiraPartnerTrackingEvents,
  klaviyoPartnerTrackingEvents,
  linearPartnerTrackingEvents,
  loyaltyLionPartnerTrackingEvents,
  rechargePartnerTrackingEvents,
  shopifyPartnerTrackingEvents,
  voyadoPartnerTrackingEvents,
  rivoLoyaltyPartnerTrackingEvents,
} from './tracking';

/**
 * Here we initialize the event handling of the Partner Integration widgets. In
 * order to not use `analytics` directly in the widgets we emmit our own events
 * and create listeners to forward each to `analytics`. This way the partner
 * team is decoupled from the tracking implementation in agent-interface.
 */
export const initPartnerIntegrationsEvents = (): void => {
  const partnerEvents = initializePartnerEventEmitter();

  if (partnerEvents) {
    commonPartnerTrackingEvents({ partnerEvents });
    shopifyPartnerTrackingEvents({ partnerEvents });
    jiraPartnerTrackingEvents({ partnerEvents });
    linearPartnerTrackingEvents({ partnerEvents });
    githubPartnerTrackingEvents({ partnerEvents });
    klaviyoPartnerTrackingEvents({ partnerEvents });
    voyadoPartnerTrackingEvents({ partnerEvents });
    loyaltyLionPartnerTrackingEvents({ partnerEvents });
    rechargePartnerTrackingEvents({ partnerEvents });
    brazePartnerTrackingEvents({ partnerEvents });
    rivoLoyaltyPartnerTrackingEvents({ partnerEvents });
  }
};
